const locale = {
  placeholder: 'Zeit auswählen',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/de_DE.js